import React, { useState, useEffect } from 'react';
import MaintenanceMode from '../pages/MaintenanceMode';

/**
 * MaintenanceWrapper Component
 * 
 * Automatically shows Maintenance page when system is under maintenance
 * 
 * Usage:
 * 1. Wrap your app with this component
 * 2. Set maintenance mode via:
 *    - Environment variable (REACT_APP_MAINTENANCE_MODE=true)
 *    - API endpoint (checks /api/status)
 *    - localStorage (localStorage.setItem('maintenanceMode', 'true'))
 */

const MaintenanceWrapper = ({ children }) => {
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkMaintenanceStatus();
  }, []);

  const checkMaintenanceStatus = async () => {
    try {
      // Method 1: Check environment variable
      const envMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
      
      // Method 2: Check localStorage (for quick toggling)
      const localMaintenance = localStorage.getItem('maintenanceMode') === 'true';
      
      // Method 3: Check API endpoint (uncomment to use)
      /*
      const response = await fetch('/api/status');
      const data = await response.json();
      const apiMaintenance = data.maintenance === true;
      */

      // Set maintenance mode if any method returns true
      const maintenanceActive = envMaintenance || localMaintenance; // || apiMaintenance
      
      setIsUnderMaintenance(maintenanceActive);
      setLoading(false);
    } catch (error) {
      console.error('Error checking maintenance status:', error);
      // If error, assume not in maintenance mode
      setIsUnderMaintenance(false);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f8fafc'
      }}>
        <div style={{
          textAlign: 'center',
          color: '#64748b'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e2e8f0',
            borderTopColor: '#3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }} />
          Loading...
        </div>
      </div>
    );
  }

  // Show maintenance page if system is under maintenance
  if (isUnderMaintenance) {
    return <MaintenanceMode />;
  }

  // Otherwise, show normal app
  return <>{children}</>;
};

export default MaintenanceWrapper;

